import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';

function DashboardHeader({ loading, onRefresh }) {
  const { t } = useTranslation();

  return (
    <Box 
      display="flex" 
      justifyContent="space-between" 
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      flexDirection={{ xs: 'column', sm: 'row' }}
      gap={{ xs: 2, sm: 0 }}
      mb={4}
    >
      {/* Left Side - Title & Description */}
      <Box>
        <Box display="flex" alignItems="center" gap={1.5} mb={0.5}>
          <Typography 
            variant="h4" 
            sx={{
              fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
              fontWeight: 700,
              color: 'text.primary',
              letterSpacing: -0.5
            }}
          >
            {t('saturation.title')}
          </Typography>
        </Box>
        
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{
            fontSize: { xs: '0.8rem', sm: '0.875rem' },
            fontWeight: 500
          }}
        >
          {t('saturation.subtitle')}
        </Typography>
      </Box>

      {/* Right Side - Action Button */}
      <Button
        variant="outlined"
        startIcon={<RefreshIcon />}
        onClick={onRefresh}
        disabled={loading}
        sx={{
          minWidth: '140px',
          height: '48px',
          fontWeight: 600,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            backgroundColor: 'primary.light',
            color: 'white'
          }
        }}
      >
        {t('saturation.refresh')}
      </Button>
    </Box>
  );
}

export default DashboardHeader;